import { connect } from "react-redux";

import { generateOtpCodePromisify } from "../../store/actions/otp";
import { getProspectInfoPromisify } from "../../store/actions/retrieveApplicantInfo";
import RestartOTP from "./RestartOTP";

export { Otp } from "./Otp";

export const mapDispatchToProps = {
  generateOtp: generateOtpCodePromisify,
  prospectInfo: getProspectInfoPromisify
};

export default connect(
  null,
  mapDispatchToProps
)(RestartOTP);
